import React, { useState, useRef, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import toast from 'react-hot-toast';
import ACTIONS from '../Actions';
import Client from '../components/Client';
import Editor from '../components/Editor';
import { initSocket } from '../socket';
import { executeCode } from '../api';
import {
    useLocation,
    useNavigate,
    Navigate,
    useParams,
} from 'react-router-dom';

const EditorPage = () => {
    const { isAuthenticated, loginWithRedirect, logout, user } = useAuth0();
    const [language, setLanguage] = useState('javascript');
    const [output, setOutput] = useState('');


    const socketRef = useRef(null);
    const codeRef = useRef(null);
    const location = useLocation();
    const { roomId } = useParams();
    const reactNavigator = useNavigate();
    const [clients, setClients] = useState([]);
    const [isError, setIsError] = useState(false);



    const runCode = async () => {
        const code = codeRef.current;
        try {
            const response = await executeCode(language, code);
            if (response.data && response.data.run) {
                const { stdout, stderr } = response.data.run;
                setOutput(stdout ? stdout : stderr);
                console.log('Output:', stdout ? stdout : stderr);
                stderr ? setIsError(true) : setIsError(false);

            } else {
                console.error('Unexpected API response:', response);
            }
        } catch (error) {
            console.error('Error running code:', error);
            
        }
    };

    useEffect(() => {
        const init = async () => {
            socketRef.current = await initSocket();
            socketRef.current.on('connect_error', (err) => handleErrors(err));
            socketRef.current.on('connect_failed', (err) => handleErrors(err));

            function handleErrors(e) {
                console.log('socket error', e);
                toast.error('Socket connection failed, try again later.');
                reactNavigator('/');
            }

            socketRef.current.emit(ACTIONS.JOIN, {
                roomId,
                username: location.state?.username,
            });

            // Listening for joined event
            socketRef.current.on(
                ACTIONS.JOINED,
                ({ clients, username, socketId }) => {
                    if (username !== location.state?.username) {
                        toast.success(`${username} joined the room.`);
                        console.log(`${username} joined`);
                    }
                    setClients(clients);
                    socketRef.current.emit(ACTIONS.SYNC_CODE, {
                        code: codeRef.current,
                        socketId,
                    });
                }
            );

            // Listening for disconnected
            socketRef.current.on(
                ACTIONS.DISCONNECTED,
                ({ socketId, username }) => {
                    toast.success(`${username} left the room.`);
                    setClients((prev) => {
                        return prev.filter(
                            (client) => client.socketId !== socketId
                        );
                    });
                }
            );
        };
        init();
        return () => {
            socketRef.current.disconnect();
            socketRef.current.off(ACTIONS.JOINED);
            socketRef.current.off(ACTIONS.DISCONNECTED);
        };
    }, []);

    async function copyRoomId() {
        try {
            await navigator.clipboard.writeText(roomId);
            toast.success('Room ID has been copied to your clipboard');
        } catch (err) {
            toast.error('Could not copy the Room ID');
            console.error(err);
        }
    }

    function leaveRoom() {
        reactNavigator('/');
    }

    if (!location.state) {
        return <Navigate to="/" />;
    }

    return (
        <div className="mainWrap">
            <div className="aside">
                <div className="asideInner">
                    <div className="logo">
                        <img
                            className="logoImage"
                            src="/code-nitte.png"
                            alt="logo"
                        />
                    </div>
                    <h3>Connected</h3>
                    <div className="clientsList">
                        {clients.map((client) => (
                            <Client
                                key={client.socketId}
                                username={client.username}
                            />
                        ))}
                    </div>
                </div>
                <button className="btn copyBtn" onClick={copyRoomId}>
                    Copy ROOM ID
                </button>
                <select value={language} onChange={(e) => setLanguage(e.target.value)}
                    style={{
                        padding: '10px',
                        fontSize: '16px',
                        border: 'none',
                        borderRadius: '5px',
                        boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                        outline: 'none',
                        margin: '10px 0',
                    }}>
                    <option value="javascript">JavaScript</option>
                    <option value="typescript">TypeScript</option>
                    <option value="python">Python</option>
                    <option value="csharp">C#</option>
                    <option value="php">Php</option>
                    <option value="java">Java</option>
                </select>
                
                <button className="btn runBtn" onClick={runCode}>
                    RUN
                </button>
                <button className="btn logoutBtn" onClick={() => logout({ returnTo: window.location.origin })}>
    Log Out
</button>

                <button className="btn leaveBtn" onClick={leaveRoom}>
                    Leave
                </button>
            </div>
            <div className="gridContainer">
            <div className="start-border"> </div>
                <div className="editorWrap">
                    <Editor
                        socketRef={socketRef}
                        roomId={roomId}
                        
                        onCodeChange={(code) => {
                            codeRef.current = code;
                        }}
                    />
                </div>
                <div className="lineWrap"></div>
                <div className="outputWrap" style={{ backgroundColor: '#000', padding: '10px', overflowX: 'auto' ,display:'flex',flexDirection:'column', flexWrap:'wrap'}}>
                <div className="terminal">Console 

</div>
  <pre style={{
   color: output ? (isError ? "red" : "hsl(0, 0%, 90%)") : "gray",

    fontSize: '16px',
    fontFamily: 'Arial, sans-serif',
    overflowWrap: 'break-word',
  }}>
    {output || 'Click "Run Code" to see the output here'}
  </pre>
</div>




            </div>
        </div>
    );
};

export default EditorPage;
